import Image from 'next/image'

import { Text } from '@wartek-id/text'
import { Button } from '@wartek-id/button-v1'

export const KSReviewSheetContent = (props) => {
  const { sheetType, onChangeSheetState, onContinueClick, onSubmissionClick } =
    props

  if (sheetType === 'confirm')
    return (
      <>
        <div className="flex flex-col ">
          <Text variant="heading-sm" className=" mb-1">
            Kumpulkan berkas?
          </Text>
          <Text variant="body-sm" color="subdued" className="my-2">
            Pastikan semua berkas yang Anda kumpulkan benar dan memenuhi syarat.
            Setelah dikumpulkan, berkas tidak dapat dihapus/diubah.
          </Text>
        </div>
        <Button
          className="my-2"
          color="blue"
          fullWidth
          onClick={() => onSubmissionClick()}
        >
          Ya, kumpulkan sekarang
        </Button>
        <Button
          color="white"
          className="mb-2"
          fullWidth
          onClick={() => onChangeSheetState(false)}
        >
          Cek ulang berkas
        </Button>
      </>
    )

  return (
    <>
      <div className="flex flex-row items-start">
        <div>
          <Text variant="action" className="mb-1">
            Berkas berhasil dikumpulkan dan akan dicek oleh Dinas!
          </Text>
          <Text variant="body-sm" color="subdued" className="my-2 mb-4">
            Hasil pengecekannya akan diumumkan nanti pada Seleksi Kepala Sekolah
            di Beranda.
          </Text>
        </div>
        <Image
          src={'/images/bcks/img-folder-file-document-download.png'}
          alt={'image-placeholder'}
          width={100}
          height={100}
        />
      </div>
      <Button color="black" fullWidth onClick={onContinueClick}>
        Saya Mengerti
      </Button>
    </>
  )
}
